import { OutkeepPermission } from '@outkeep/shared';
import type { AssignedToMeFilterUser } from './assigned-to-me-filter.types';

const BROADER_REQUEST_SCOPE_PERMISSIONS = [
  OutkeepPermission.LogistViewAllRequests,
  OutkeepPermission.LogistViewRequestsForUs,
  OutkeepPermission.LogistViewMyOwnRequests,
  OutkeepPermission.LogistViewCompanyRequests,
  OutkeepPermission.LogistViewMySubdivisionRequests,
  OutkeepPermission.LogistViewAccessibleCounterpartiesRequests,
  OutkeepPermission.LogistViewCounterpartiesAccessPointsRequests,
] as const;

export function canShowAssignedToMeFilter(
  user: AssignedToMeFilterUser | null,
): boolean {
  const modules = user?.modules;
  const personId = user?.personId;

  if (!personId) {
    return false;
  }

  return Boolean(
    user &&
    modules?.[OutkeepPermission.LogistViewMyRequests] &&
    BROADER_REQUEST_SCOPE_PERMISSIONS.some(permission =>
      Boolean(modules[permission]),
    ),
  );
}
